import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'lucky-gift-popup',
  templateUrl: './lucky-gift-popup.component.html',
  styleUrls: ['./lucky-gift-popup.component.scss'],
})
export class LuckyGiftPopupComponent implements OnInit {

  @Input()
  public giftName: string;
  @Input()
  public giftImage: string;
  @Output()
  public event: EventEmitter<string> = new EventEmitter<string>();
  
  public tryAgain: boolean = false;
  constructor() {
  }

  ngOnInit() {
    if(this.giftName && this.giftName.toLowerCase().indexOf('chúc bạn') != -1){
      this.tryAgain = true;
    }
  }

  close(){
    this.event.emit('CLOSE');
  }
}
